// Utility functions for text processing

/**
 * Strip HTML tags and collapse excessive whitespace.
 * @param {string} html
 * @returns {string}
 */
export function stripHtml(html) {
  if (!html || typeof html !== "string") return "";
  // Remove script/style contents first
  const withoutScriptStyle = html
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");

  // Remove all tags
  const withoutTags = withoutScriptStyle.replace(/<[^>]+>/g, " ");

  // Decode a few common entities
  const decoded = withoutTags
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

  // Collapse whitespace
  return decoded.replace(/\s+/g, " ").trim();
}
